import { render, staticRenderFns } from "./MessageBuilder.vue?vue&type=template&id=2ba8b09d"
import script from "./MessageBuilder.vue?vue&type=script&lang=js"
export * from "./MessageBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports